import { render, staticRenderFns } from "./KycSettings.vue?vue&type=template&id=6598546c&scoped=true"
import script from "./KycSettings.vue?vue&type=script&lang=js"
export * from "./KycSettings.vue?vue&type=script&lang=js"
import style0 from "./KycSettings.vue?vue&type=style&index=0&id=6598546c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6598546c",
  null
  
)

export default component.exports